<template>
  <span v-bind="$attrs" v-on="$listeners">{{ formattedTimeString }}</span>
</template>

<script>
import { mapState } from 'vuex'

// import Logger from '@/lib/Logger'

export default {
  props: {
    time: {
      type: String,
      required: true,
    },
    dateOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    //
  }),

  computed: {
    browserLanguageCode() {
      return navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en'
    },

    formattedTimeString() {
      const dateObj = new Date(this.time)
      let outputString = ''
      switch (this.userTimePreference) {
        case 'utc':
          outputString = this.dateOnly
            ? dateObj
                .toUTCString()
                .split(' ')
                .slice(0, -2)
                .join(' ')
            : dateObj.toUTCString()
          break
        case 'gmt':
          outputString = this.dateOnly
            ? dateObj
                .toUTCString()
                .split(' ')
                .slice(0, -2)
                .join(' ')
            : dateObj.toUTCString()
          break
        case 'iso':
          outputString = this.dateOnly
            ? dateObj
                .toISOString()
                .split('T')
                .slice(0, -1)
                .join(' ')
            : dateObj.toISOString()
          break
        case 'locale':
          outputString = this.dateOnly
            ? dateObj.toLocaleDateString(this.browserLanguageCode, { dateStyle: 'medium' })
            : dateObj.toLocaleString(this.browserLanguageCode, {
                dateStyle: 'medium',
                timeStyle: 'long',
              })
          break
        default:
          outputString = 'unsuppored format'
      }
      return outputString
    },
    ...mapState(['userTimePreference']),
  },

  methods: {
    //
  },
}
</script>

<style></style>
